import { shikiToMonaco } from '@shikijs/monaco'
import * as monaco from 'monaco-editor'
import { createHighlighter } from 'shiki'

export const initializeMonaco = async () => {
  const highlighter = await createHighlighter({
    langs: ['xml', 'markdown', 'yaml', 'toml', 'json', 'java', 'csv'],
    langAlias: {
      raml: 'yaml',
      dataweave: 'yaml',
      dwl: 'yaml',
      example: 'yaml',
      task: 'yaml'
    },
    themes: ['github-light', 'min-dark']
  })

  monaco.languages.register({ id: 'json' })
  monaco.languages.register({ id: 'xml' })
  monaco.languages.register({ id: 'dataweave' })
  monaco.languages.register({ id: 'dwl' })
  monaco.languages.register({ id: 'csv' })
  monaco.languages.register({ id: 'yaml' })

  shikiToMonaco(highlighter as any, monaco as any)
}

export const MONACO_COMMON_OPTIONS = {
  minimap: { enabled: false },
  diffCodeLens: true,
  fontFamily: 'Menlo, Monaco, "Courier New", monospace',
  fontSize: 12,
  language: 'xml',
  theme: 'github-light',
  cursorBlinking: 'blink',
  cursorStyle: 'line',
  cursorWidth: 1,
  renderWhitespace: 'all',
  ignoreTrimWhitespace: false,
  renderControlCharacters: true,
  scrollbar: {
    vertical: 'hidden',
    horizontal: 'hidden',
    verticalScrollbarSize: 0,
    horizontalScrollbarSize: 0,
    alwaysConsumeMouseWheel: false
  },
  overviewRulerBorder: false,
  overviewRulerLanes: 0,
  wordWrap: 'on'
} as monaco.editor.IStandaloneEditorConstructionOptions

export const getMonacoOptions = (
  readOnly = false
): monaco.editor.IStandaloneEditorConstructionOptions => ({
  ...MONACO_COMMON_OPTIONS,
  readOnly
})
